import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMainWalletSetting } from '../../services'
import { MainWalletSettingQueryKeys } from '@/modules/client-setting/keys'
import { GetMainWalletSettingResponse } from '@/modules/client-setting/type'

export default function useQueryGetMainWalletSetting(
	props?: UseBaseQueryOptions<GetMainWalletSettingResponse>,
) {
	return useQuery({
		queryKey: [MainWalletSettingQueryKeys.GetMainWalletSetting],
		queryFn: () => getMainWalletSetting(),
		...props,
	})
}
